/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateBrandMemoryDto } from '../models/CreateBrandMemoryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandMemoryService {
    /**
     * List Brand-Memory bullets + overall brand completeness.
     * @returns any
     * @throws ApiError
     */
    public static brandMemoryControllerListV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brand-memories',
        });
    }
    /**
     * Add a durable Brand-Memory bullet (a user-entered fact).
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static brandMemoryControllerCreateV1(
        requestBody: CreateBrandMemoryDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/brand-memories',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Edit a Brand-Memory bullet's text.
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static brandMemoryControllerUpdateV1(
        id: string,
        requestBody: CreateBrandMemoryDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/brand-memories/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove a Brand-Memory bullet by id.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static brandMemoryControllerRemoveV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/brand-memories/{id}',
            path: {
                'id': id,
            },
        });
    }
}
